export default {
      id: "icon-summer-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-summer",
      toString: function () {
        return this.url;
      }
    }